export default {"src":"/_next/static/media/ee.ad47e7eb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};